module.exports = __webpack_public_path__ + "static/media/ar.d205ca13.svg";